/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetZReport200ResponseMoneyEarnedLinesInner } from './GetZReport200ResponseMoneyEarnedLinesInner';
import {
    GetZReport200ResponseMoneyEarnedLinesInnerFromJSON,
    GetZReport200ResponseMoneyEarnedLinesInnerFromJSONTyped,
    GetZReport200ResponseMoneyEarnedLinesInnerToJSON,
    GetZReport200ResponseMoneyEarnedLinesInnerToJSONTyped,
} from './GetZReport200ResponseMoneyEarnedLinesInner';

/**
 * 
 * @export
 * @interface GetZReport200ResponseMoneyEarned
 */
export interface GetZReport200ResponseMoneyEarned {
    /**
     * 
     * @type {Array<GetZReport200ResponseMoneyEarnedLinesInner>}
     * @memberof GetZReport200ResponseMoneyEarned
     */
    lines: Array<GetZReport200ResponseMoneyEarnedLinesInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetZReport200ResponseMoneyEarned
     */
    dates: Array<string>;
}

/**
 * Check if a given object implements the GetZReport200ResponseMoneyEarned interface.
 */
export function instanceOfGetZReport200ResponseMoneyEarned(value: object): value is GetZReport200ResponseMoneyEarned {
    if (!('lines' in value) || value['lines'] === undefined) return false;
    if (!('dates' in value) || value['dates'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseMoneyEarnedFromJSON(json: any): GetZReport200ResponseMoneyEarned {
    return GetZReport200ResponseMoneyEarnedFromJSONTyped(json, false);
}

export function GetZReport200ResponseMoneyEarnedFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200ResponseMoneyEarned {
    if (json == null) {
        return json;
    }
    return {
        
        'lines': ((json['lines'] as Array<any>).map(GetZReport200ResponseMoneyEarnedLinesInnerFromJSON)),
        'dates': json['dates'],
    };
}

export function GetZReport200ResponseMoneyEarnedToJSON(json: any): GetZReport200ResponseMoneyEarned {
    return GetZReport200ResponseMoneyEarnedToJSONTyped(json, false);
}

export function GetZReport200ResponseMoneyEarnedToJSONTyped(value?: GetZReport200ResponseMoneyEarned | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lines': ((value['lines'] as Array<any>).map(GetZReport200ResponseMoneyEarnedLinesInnerToJSON)),
        'dates': value['dates'],
    };
}

